import { ServiceLogo } from '@on3/ui-lib/components/ServiceLogo/ServiceLogo';
import { useSubscribe } from '@on3/ui-lib/components/Subscription/Provider';
import { type TOCTemplateProps } from '@on3/ui-lib/components/Subscription/Templates/TopOfContent';
import { TheAthletic } from '@on3/ui-lib/components/Svg/TheAthletic';
import clsx from 'clsx';

import styles from './TheAthleticTOC.module.scss';

export const TheAthleticTOC = ({
  handleJoin,
  template,
  preview,
}: TOCTemplateProps) => {
  const { subscribeText } = useSubscribe();

  const title =
    template.data.title ||
    'Subscribe to On3 annual and enjoy a full year of The Athletic';
  const lineOne = template.data.line1;
  const lineTwo = template.data.line2;
  const btnText = template.planData1?.buttonText || subscribeText || 'Join Now';
  const planKey = template.planKey1;

  return (
    <div
      className={clsx(styles.block, { [styles.preview]: preview })}
      data-template-type="top-of-content"
    >
      <div className={styles.top}>
        {lineOne && <div className={styles.lineOne}>{lineOne}</div>}
        {lineTwo && <div className={styles.lineTwo}>{lineTwo}</div>}
      </div>
      <figure className={styles.logos}>
        <div className={styles.on3}>
          <ServiceLogo type="on3" />
        </div>
        <div className={styles.divider} />
        <TheAthletic />
      </figure>
      <div className={styles.title}>{title}</div>
      <button
        className={styles.joinBtn}
        onClick={() => handleJoin(planKey)}
        type="button"
      >
        {btnText}
      </button>
    </div>
  );
};
